var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVbSizefitIllustrations20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272.3 307.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #231f20;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        stroke: #ed1c24;\n        stroke-dasharray: 1;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 0.5,
    y: 0.5,
    width: 271.3,
    height: 306.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.26,26.1c1.79,11.77,2.26,20.5,5.15,32.04,2.02,8.08,5.97,16.74,6.64,25.01.7,8.68-2.93,17.38-6.67,25.01-10.19,20.81-21.92,41.6-27.27,64.31-4.51,19.17-5.18,39.26-1.77,58.66,3.33,18.98,10.43,36.89,11.12,56.42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.95,26.1c-1.79,11.77-2.26,20.5-5.15,32.04-2.02,8.08-5.97,16.74-6.64,25.01-.7,8.68,2.93,17.38,6.67,25.01,10.19,20.81,21.92,41.6,27.27,64.31,4.51,19.17,5.18,39.26,1.77,58.66-3.33,18.98-10.43,36.89-11.12,56.42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.12,147.31s-24.2,37.46-7.63,82.55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.76,149.09s24.2,37.46,7.63,82.55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbSizefitIllustrations20);
export default __webpack_public_path__ + "static/media/VB_SIZE&FIT_ILLUSTRATIONS-20.abf451dc5b9af431a8d6316ce676658b.svg";
export { ForwardRef as ReactComponent };